import type { ComponentRegistry } from '@vibesites/runtime';
import {
  Header,
  Footer,
  SpecialOfferBanner,
  Hero,
  PropertyOverview,
  FloorplansList,
  AmenitiesList,
  NeighborhoodCallout,
  LifestyleHighlights,
  VisitUs,
  PageHero,
  AmenityHighlights,
  AhaBand,
  AmenityGroups,
  PetPolicy,
  Reviews,
  ReviewThemes,
  ReviewsList,
  NextStep,
  AroundTheArea,
  SchoolsNearby,
  PrivacyPolicyContent,
  AccessibilityStatement,
  HyperlocalHero,
  HyperlocalPageCopy,
  FaqSearch,
  FaqCategoryBar,
  FaqList,
  FaqHelp,
  FloorPlansHero,
  FloorPlansCompare,
  InteractiveMapCallout,
  TourOptions,
  GalleryCategoryBar,
  GalleryMosaic,
  HomeFeatures,
  FeesAndPets,
  Fees,
  PetRules,
  TourHero,
  TourScheduler,
  TourSteps,
  TourGallery,
  TourQuestions,
  ContactDetails,
  VirtualTourEmbed,
  SitemapList,
  EngrainSitemapEmbed,
} from './components';
import './styles/theme.css';

export const registry: ComponentRegistry = {
  Header,
  Footer,
  SpecialOfferBanner,
  Hero,
  PropertyOverview,
  FloorplansList,
  AmenitiesList,
  NeighborhoodCallout,
  LifestyleHighlights,
  VisitUs,
  PageHero,
  AmenityHighlights,
  AhaBand,
  AmenityGroups,
  PetPolicy,
  Reviews,
  ReviewThemes,
  ReviewsList,
  NextStep,
  AroundTheArea,
  SchoolsNearby,
  PrivacyPolicyContent,
  AccessibilityStatement,
  HyperlocalHero,
  HyperlocalPageCopy,
  FaqSearch,
  FaqCategoryBar,
  FaqList,
  FaqHelp,
  FloorPlansHero,
  FloorPlansCompare,
  InteractiveMapCallout,
  TourOptions,
  GalleryCategoryBar,
  GalleryMosaic,
  HomeFeatures,
  FeesAndPets,
  Fees,
  PetRules,
  TourHero,
  TourScheduler,
  TourSteps,
  TourGallery,
  TourQuestions,
  ContactDetails,
  VirtualTourEmbed,
  SitemapList,
  EngrainSitemapEmbed,
};

export default registry;
